/* Stiletto owns all cart requests and Add buttons. This element only remembers dismissal. */
(() => {
  const tag = 'agw-flint-hill-cart-offer';
  const dismissalKey = 'agw:flint-hill-accessories:dismissed:v1';
  let dismissed = false;
  if (customElements.get(tag)) return;

  class FlintHillCartOffer extends HTMLElement {
    connectedCallback() {
      try {
        dismissed = dismissed || sessionStorage.getItem(dismissalKey) === '1';
      } catch (_) {
        // Storage restrictions must never prevent shopping or checkout.
      }
      this.hidden = dismissed;
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      if (!event.target.closest('[data-flint-hill-dismiss]')) return;
      dismissed = true;
      try {
        sessionStorage.setItem(dismissalKey, '1');
      } catch (_) { /* Keep in-memory dismissal when browser storage is unavailable. */ }
      this.hidden = true;
      this.closest('.quick-cart')?.querySelector('[name="checkout"]')?.focus();
    };
  }

  customElements.define(tag, FlintHillCartOffer);
})();
